<template>
  <!-- 业务场景 -->
  <div>
    <!-- <Header :nowActive="nowActive" v-if="isMobile==false"></Header> -->
    <!-- <div v-if="isMobile==false"><PublicBanner></PublicBanner></div> -->
    <div style="width: 100%">
      <img style="width: 100%" src="../assets/img/businessScenario.jpg" />
    </div>
    <!-- <Publicfooter ref="footer" v-if="isMobile==false" v-show="false" ></Publicfooter> -->
  </div>
</template>

<script>
import Header from "../components/header.vue";
import PublicBanner from "../components/banner.vue";
import Publicfooter from "../components/footer.vue";
export default {
  components: {
    Header,
    PublicBanner,
    Publicfooter,
  },
  data() {
    return {
      nowActive: ["businessScenario"],
	  isMobile:false
    };
  },
  mounted(){
    // this.isMobile = this.$refs.footer.isMobile;
  },
};
</script>

<style>
</style>
